import React, { useEffect, useRef, useState } from 'react';
import { Snackbar, Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { applyUpdate, SW_UPDATE_EVENT } from '../serviceWorkerRegistration';

// Prompts the user when a newer build has been downloaded and is waiting to
// activate. This is what keeps offline caching safe during active development:
// a new deploy is always offered, never silently withheld behind a stale cache.
export default function UpdateAvailableSnackbar() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const registrationRef = useRef(null);

  useEffect(() => {
    const onUpdate = (e) => {
      registrationRef.current = (e && e.detail && e.detail.registration) || null;
      setOpen(true);
    };
    window.addEventListener(SW_UPDATE_EVENT, onUpdate);
    return () => window.removeEventListener(SW_UPDATE_EVENT, onUpdate);
  }, []);

  const handleReload = () => {
    setOpen(false);
    applyUpdate(registrationRef.current);
  };

  return (
    <Snackbar open={open} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
      <Alert
        severity="info"
        variant="filled"
        sx={{ width: '100%' }}
        action={
          <Button color="inherit" size="small" onClick={handleReload}>
            {t('update.reload') || 'Reload'}
          </Button>
        }
      >
        {t('update.available') || 'A new version of the app is available.'}
      </Alert>
    </Snackbar>
  );
}
